module.exports = __webpack_public_path__ + "img/start-charging-mobile.ca7b4213.webp";